import type { ConfirmFn } from "./use-confirm"
import { createContext } from "react"

export const ConfirmContext = createContext<ConfirmFn | undefined>(undefined)
